<div class="ruckit-driver-reference-selector">
  <div class="ruckit-driver-reference-selector__search-bar">
    <i
      *ngIf="visible"
      class="icon-close ruckit-driver-reference-selector__search-bar__close"
      (click)="onCloseClick()"
    >
    </i>
    <i
      *ngIf="hasControls && !visible"
      class="icon-pencil ruckit-driver-reference-selector__search-bar__edit"
      [ngClass]="{'icon-disabled': !selectedDriverReference}"
      (click)="selectedDriverReference && onEditReferenceClick()"
    >
    </i>
    <i
      *ngIf="hasControls && !visible"
      class="icon-search ruckit-driver-reference-selector__search-bar__search"
      (click)="onInputFocus()"
    >
    </i>
    <input
      #driverReferenceInput
      matInput
      class="search"
      type="text"
      [disabled]="!visible"
      (blur)="onInputBlur()"
      (input)="onSearchChange($event.target.value)"
      (focus)="onInputFocus()"
      [(ngModel)]="value"
    />
  </div>
  <div class="ruckit-driver-reference-selector__results--container">
    <div
      *ngIf="visible"
      class="ruckit-driver-reference-selector__results"
      infiniteScroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollUpDistance]="scrollUpDistance"
      [infiniteScrollThrottle]="throttle"
      [scrollWindow]="false"
      (scrolled)="onScrollDown()"
      (scrolledUp)="onScrollUp()"
    >
      <div *ngIf="loading" class="ruckit-driver-reference-selector__results__loader">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
      <div *ngIf="!loading && references.length <= 0" class="ruckit-driver-reference-selector__results__missing">
        <div class="ruckit-driver-reference-selector__result">
          No References Found
        </div>
      </div>
      <div *ngFor="let reference of references">
        <div class="ruckit-driver-reference-selector__result" (mousedown)="onReferenceClicked($event, reference)">
          <div class="ruckit-driver-reference-selector__result__title">
            {{ reference.customerName }} - {{ reference.customerCode }}
          </div>
          <div class="ruckit-driver-reference-selector__result__content">
            <div class="ruckit-driver-reference-selector__result__content__item">
              <div class="ruckit-driver-reference-selector__result__content__item__header">{{ 'Driver Name' | translate }}</div>
              <div class="ruckit-driver-reference-selector__result__content__item__content">{{ reference.driverName }}</div>
            </div>
            <div class="ruckit-driver-reference-selector__result__content__item">
              <div class="ruckit-driver-reference-selector__result__content__item__header">{{ 'Driver Code' | translate }}</div>
              <div class="ruckit-driver-reference-selector__result__content__item__content">{{ reference.driverCode }}</div>
            </div>
            <div class="ruckit-driver-reference-selector__result__content__item">
              <div class="ruckit-driver-reference-selector__result__content__item__header">{{ 'Email Address' | translate }}</div>
              <div class="ruckit-driver-reference-selector__result__content__item__content">{{ reference.email }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="visible" class="ruckit-driver-reference-selector__footer">
      <i class="icon icon-plus"></i>
      <div class="ruckit-driver-reference-selector__footer__content" (mousedown)="onAddClick()">
        {{ 'Add New Driver Reference' | translate }}
      </div>
    </div>
  </div>
</div>
